var baseStyle = {
  textStyle: 'text',
  marginBottom: 6
};
var sizes = {
  xs: {
    fontSize: 'xs'
  },
  sm: {
    fontSize: 'sm'
  },
  md: {
    fontSize: 'md'
  },
  lg: {
    fontSize: 'lg'
  }
};
var defaultProps = {
  size: 'md'
};
var Text = {
  sizes: sizes,
  baseStyle: baseStyle,
  defaultProps: defaultProps
};
export { Text as default };